import React, { useState } from 'react';
import Message from '../../Message';
import SuccessRes from './SuccessRes';
import { addShippingCostSchema } from '../../../../joi/shippingSchema';
import { addShippingCostSetData } from '../../../../../context/api/shipping/add-cost/addShippingCostSetData';
import { useCookies } from 'react-cookie';
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect } from "react";
import Joi from 'joi';

const AddCostModal = ({
  show,
  onHide,
  lang,
  dataTranslate,
  data,
  setRefreshData,
}) => {
  const schema = addShippingCostSchema(lang);
  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };
  const [cost, setCost] = useState({
    onName: "",
    phoneNumber: "",
    costAmount: 0,
    NB: ""
  });
  const [errors, setErrors] = useState({});
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);

  const addShippingCost = () => {
    var objectSchema = Joi.object().keys(schema);
    const result = objectSchema.validate(cost, { abortEarly: false });
    const { error } = result;
    if (!error) {
      // pass the payload to the context API to do the request
      setBtnLoader(() => true);
      return addShippingCostSetData(
        lang,
        setMessageResponse,
        cookies,
        cost,
        setSuccessMessage,
        setBtnLoader,
        data.id
      );
    } else {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      setErrors(errorData);
      return errorData;
    }
  }

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    let errorData = { ...errors };
    const errorMessage = validateProperty(e);
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      delete errorData[name];
    }
    let costData = { ...cost };
    costData[name] = value;
    setCost(costData);
    setErrors(errorData);
  }

  const validateProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = schema[name];
    const result = subSchema.validate(value);
    const { error } = result;
    return error ? error.details[0].message : null;
  };

  const reset = () => {
    setCost({
      onName: "",
      phoneNumber: "",
      costAmount: 0,
      NB: ""
    })
    setErrors({

    })
  }

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>
                  {dataTranslate.popups.add_shipping_cost.add_title}
                  <span style={{ color: "red" }}> {data.id}</span>
                </span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_shipping_cost.onName}
                          {<span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>}
                        </Form.Label>
                        <Form.Control
                          name="onName"
                          placeholder={
                            dataTranslate.popups.add_shipping_cost.onName_p
                          }
                          defaultValue=""
                          onChange={handleOnChange}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {errors.onName}
                      </Form.Text>
                    </Col>

                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_shipping_cost.phoneNumber}
                        </Form.Label>
                        <Form.Control
                          name="phoneNumber"
                          placeholder={
                            dataTranslate.popups.add_shipping_cost.phoneNumber_p
                          }
                          defaultValue=""
                          onChange={handleOnChange}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {errors.phoneNumber}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_shipping_cost.costAmount}
                          {<span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>}
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="costAmount"
                          placeholder={
                            dataTranslate.popups.add_shipping_cost.costAmount_p
                          }
                          defaultValue=""
                          onChange={handleOnChange}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {errors.costAmount}
                      </Form.Text>
                    </Col>

                    <Col lg={6} sm={12} className="mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_shipping_cost.NB}
                        </Form.Label>
                        <Form.Control
                          name="NB"
                          as="textarea"
                          placeholder={
                            dataTranslate.popups.add_shipping_cost.NB
                          }
                          defaultValue=""
                          onChange={handleOnChange}
                        />
                        <Form.Text style={{ color: "red" }}>
                          {errors.NB}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                  onClick={(e) => {
                    addShippingCost();
                  }}
                  disabled={btnLoader ? true : false}
                >
                  {dataTranslate.popups.add_shipping_cost.add}
                </Button>

                <Button
                  onClick={() => {
                    reset();
                    onHide();
                  }}
                >
                  {dataTranslate.popups.add_shipping_cost.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
}

export default AddCostModal;